import { Card, Grid, Typography } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import warning from 'images/warning.svg';
import { COLORS } from 'constants/design';

export interface WarningCardProps {
  intl: IntlShape;
  message: any;
  isWarning?: boolean;
  textParams?: any;
}
export const StyledWarningContainer = {
  padding: '8px',
  backgroundColor: COLORS.LIGHT_ORANGE,
  marginBottom: 15,
  width: 'fit-content',
};
const styledWarningText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  marginTop: 2,
};
const WarningCard: React.FC<WarningCardProps> = props => {
  return (
    <Card style={StyledWarningContainer} elevation={0}>
      <Grid container direction="row" alignItems="center" spacing={1}>
        <Grid item>
          <img data-testId="icon-warningCard" src={warning} alt="warning" />
        </Grid>
        <Grid item xs>
          <Typography style={styledWarningText}>{props.message}</Typography>
        </Grid>
      </Grid>
    </Card>
  );
};
export default injectIntl(WarningCard);
